import {
    FETCH_AI_CHATBOT_QUESTIONS,
    CLEAN_AI_CHATBOT_QUESTIONS,
    DELETE_AI_CHATBOT_QUESTION,
    DELETE_AI_CHATBOT_QUESTIONS,
    EDIT_AI_CHATBOT_QUESTION,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const AI_CHATBOT_QUESTIONS_DEFAULT_STATE = {};

const AiChatbotQuestionsReducer = (state = AI_CHATBOT_QUESTIONS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_AI_CHATBOT_QUESTIONS:
            return payload;

        case EDIT_AI_CHATBOT_QUESTION:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, language: payload.language, input: payload.input, output: payload.output };
                }

                return item;
            }) };

        case CLEAN_AI_CHATBOT_QUESTIONS:
        case DELETE_AI_CHATBOT_QUESTION:
        case DELETE_AI_CHATBOT_QUESTIONS:
            return AI_CHATBOT_QUESTIONS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default AiChatbotQuestionsReducer;
